real.events.on('hs:version', function(notification) {
    if (notification?.object?.tag === document.documentElement.dataset.howspaceVersion) {
        console.debug('HS :: Ignoring the version update, already running the latest version.');
    } else {
        console.debug('HS :: Updating to version ' + notification.object.tag);
        // Set a random delay of 0-30 seconds before reloading the page.
        setTimeout(() => {
            real.window.reloadPageOrNotifyUser('layout_version_updated');
        }, Math.random() * 30000);
    }
});
